import * as React from "react";
import PropTypes from 'prop-types';

const SvgWarningGeneral = props => {
  if (props.id !== "_svgwarninggeneral") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><g fill="none" fillRule="evenodd"><path d="M0 0h48v48H0z" /><path d="M36.478 32.807l-11.039-21a1.945 1.945 0 00-1.692-1.007c-.696 0-1.236.385-1.585 1.004L11.118 32.79c-.348.62-.45 1.409-.103 2.03.35.62 1.034.98 1.729.98H34.53c.848 0 1.71-.38 2.06-1.003.344-.62.233-1.37-.113-1.99zM23.15 17.961c0-.396.291-.717.65-.717s.65.321.65.717v10.257c0 .397-.291.718-.65.718s-.65-.321-.65-.718zm.65 14.271c-.539 0-.976-.449-.976-1.003s.437-1.004.976-1.004.976.45.976 1.004-.437 1.003-.976 1.003z" fill="#384048" /></g></svg>;
};

SvgWarningGeneral.displayName = "_svgwarninggeneral";
SvgWarningGeneral.propTypes = {
  id: PropTypes.string
};
SvgWarningGeneral.defaultProps = {
  id: ''
};
export default SvgWarningGeneral;